// Life is a Project — legal & contact configuration.
//
// Single source of truth for legal-page metadata. Update these values here
// and every legal page (Legal Notice, Privacy, Cookies, Terms) picks them
// up automatically in all four languages.

export const LEGAL = {
    entityName:    "Life is a Project",
    entityDescription: {
        en: "an independent personal and editorial project focused on ideas, research and projects",
        es: "un proyecto personal y editorial independiente centrado en ideas, investigación y proyectos",
        nl: "een onafhankelijk persoonlijk en redactioneel project gericht op ideeën, onderzoek en projecten",
        fr: "un projet personnel et éditorial indépendant consacré aux idées, à la recherche et aux projets",
    },
    contactEmail:  "ecastros@lifeisaproject.global",
    website:       "https://lifeisaproject.global",
    jurisdiction:  "Netherlands",
    governingLaw: {
        en: "the laws of the Netherlands, without prejudice to mandatory consumer-protection rights under EU law",
        es: "las leyes de los Países Bajos, sin perjuicio de los derechos imperativos de protección al consumidor del Derecho de la UE",
        nl: "het recht van Nederland, onverminderd dwingende consumentenbeschermingsrechten uit het EU-recht",
        fr: "le droit néerlandais, sans préjudice des droits impératifs de protection des consommateurs du droit de l’UE",
    },
    lastUpdated:   "2026-09-28",
    ga4MeasurementId: "G-WZDBEHD9VN",
};
